import { Modal } from '@components/Modal'
import { Button } from '@components/gassan-ui'
import { StyledLink } from '@components/gassan-ui/StyledLink'
import { Text } from '@components/gassan-ui/Typography/Text'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

type PrivilegesModalProps = {
  handleRequestClose: () => void
  dafDescription: string
}

export const PrivilegesModal: FC<PrivilegesModalProps> = ({
  handleRequestClose,
  dafDescription,
}) => {
  const { t } = useTranslation('account')
  return (
    <Modal
      onOpenChange={(open) => {
        if (!open) {
          handleRequestClose()
        }
      }}
      defaultOpen
      title={t('privileges.congratulations')}
    >
      <Text className="mb-6">{t('privileges.modalText')}</Text>
      <div className="flex w-full items-center justify-between">
        <StyledLink as="button" onClick={handleRequestClose}>
          {t('preferences.back')}
        </StyledLink>
        <Button variant="dark" onClick={() => handleSubmit()}>
          {t('privileges.sendEmail')}
        </Button>
      </div>
    </Modal>
  )

  function handleSubmit() {
    return window.open(
      `mailto:customercare@gassan.com?subject=${t('privileges.emailRedeem')}${dafDescription}`,
    )
  }
}
